import homebuyer1 from '../../assets/homebuyer1.svg';
import homebuyer2 from '../../assets/homebuyer2.svg';
import homebuyer3 from '../../assets/homebuyer3.svg';
import homebuyer4a from '../../assets/homebuyer4-1.svg';
import homebuyer4b from '../../assets/homebuyer4-2.svg';

export const infographicData = [
  {
    photo: homebuyer1,
    type: 'Group of Roommates',
    number: 5,
    copy:
      'of first-time buyers bought a home with individuals with whom they are not romantically involved.'
  },
  {
    photo: homebuyer2,
    type: 'Multigenerational',
    number: 14,
    copy:
      'of homebuyers were buyingwith family members for the purpose of establishing multigenerational homes'
  },
  {
    photo: homebuyer3,
    type: 'Married Couple',
    number: 61,
    copy: 'of all homebuyers'
  },
  {
    photo1: homebuyer4a,
    photo2: homebuyer4b,
    type1: 'Single Female',
    type2: 'Single Male',
    number1: 17,
    number2: 9,
    copy: 'of all homebuyers'
  }
];
